import type { RateInputs, RateOutputs } from '../types/rates';

const API_BASE_URL =
  (import.meta as { env?: Record<string, string> }).env?.VITE_RATE_API_URL ||
  'http://localhost:4000';

class RateApiClient {
  private baseUrl: string;

  constructor(baseUrl: string = API_BASE_URL) {
    this.baseUrl = baseUrl;
  }

  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`;
    
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Request failed' }));
      throw new Error(error.error || `HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }

  async lookupRates(inputs: RateInputs): Promise<RateOutputs> {
    // Check if URL contains testAssumeDate parameter
    const urlParams = new URLSearchParams(window.location.search);
    const allowTesting = urlParams.has('testAssumeDate');
    
    const endpoint = allowTesting 
      ? '/rates/lookup?allowTesting=true' 
      : '/rates/lookup';
    
    return this.request<RateOutputs>(endpoint, {
      method: 'POST',
      body: JSON.stringify(inputs),
    });
  }
}

export const rateApiClient = new RateApiClient();
